import { createUseStyles } from 'react-jss';

export default createUseStyles({
  dialog: {
    maxWidth: '1040px',
  },

  form: {
    maxWidth: '1200px',
  },

  inputsGrid: {
    display: 'grid',
    gridTemplateColumns: '45% 10% 45%',
    gridTemplateRows: 'repeat(2, 150px) repeat(3, 80px)',
    rowGap: '10px',
    gridAutoFlow: 'column',

    '& > div:nth-of-type(n+6)': {
      gridColumn: '3 / 4',
    },

    '& > div:nth-of-type(5)': {
      gridRow: '1 / 3',
      gridColumn: '3 / 4',
    },

    '& > div:nth-of-type(8)': {
      gridRow: '5 / 6',
      gridColumn: '1 / 2',
    },
    '@media(max-width: 900px)': {
      display: 'initial',
    },
  },
  alertError: {
    position: 'relative',
    bottom: '25px',
  },

  campaignTitlePart: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '30px',
    marginBottom: '40px',
    '@media(max-width: 900px)': {
      marginTop: '20px',
      justifyContent: 'center',
    },
  },

  campaignTypeLabel: {
    fontWeight: '500',
    fontSize: '16px',
    color: '#102131',
    marginTop: '12px',
    marginBottom: '36px',

    '& + div': {
      width: '45%',
      '@media(max-width: 900px)': {
        width: '100%',
      }
    },
  },

  typeFields: {
    marginTop: '56px',
    width: '45%',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },

  button: {
    width: '252px',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },
});
